<template>
  <div class="number-range">
    <a-input-group v-if="!textMode" class="compact-form-item" compact>
      <a-input-number
        class="number-input"
        v-model:value="valueOne"
        :controls="props.controls"
        :min="props.min"
        :max="props.max"
        :addon-after="props.suffix"
        :precision="precision"
        placeholder="最小值"
        @change="onNumberChange"
      />

      <a-input placeholder="~" class="separate" disabled></a-input>
      <a-input-number
        class="number-input"
        v-model:value="valueTwo"
        :controls="props.controls"
        :min="props.min"
        :max="props.max"
        :addon-after="props.suffix"
        :precision="precision"
        placeholder="最大值"
        @change="onNumberChange"
      />
    </a-input-group>
    <a-input-group v-else class="compact-form-item" compact>
      <a-input
        class="text-input"
        v-model:value="valueOne"
        placeholder="最小值"
        @change="onInputChange"
        @blur="onTextInputBlur(valueOne, 1)"
      />
      <a-input placeholder="~" class="separate" disabled></a-input>
      <a-input
        class="text-input"
        v-model:value="valueTwo"
        placeholder="最大值"
        @change="onInputChange"
        @blur="onTextInputBlur(valueTwo, 2)"
      />
    </a-input-group>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, ref, defineEmits, watch } from "vue";
import { InputGroup as AInputGroup } from "ant-design-vue";
const props = defineProps({
  value: {
    type: [Array, String],
    default: () => []
  },
  // 是否显示增减按钮
  controls: {
    type: Boolean,
    default: false
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number
  },
  suffix: {
    type: String
  },
  precision: {
    type: Number
  },
  textMode: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["update:value", "textInputBlur"]);

const valueOne = ref();
const valueTwo = ref();
const onNumberChange = () => {
  const value = [valueOne.value, valueTwo.value];
  emit(
    "update:value",
    typeof props.value === "string" ? value.join(",") : value
  );
};
watch(
  () => props.value,
  (value) => {
    if (value.length === 0) {
      valueOne.value = "";
      valueTwo.value = "";
    } else {
      valueOne.value = value[0];
      valueTwo.value = value[1];
    }
  },
  { immediate: true }
);

const onInputChange = () => {
  const value = [valueOne.value, valueTwo.value];
  emit(
    "update:value",
    typeof props.value === "string" ? value.join(",") : value
  );
};

const onTextInputBlur = (value: any, index: number) => {
  emit("textInputBlur", value, index);
};
</script>

<script lang="ts">
export default {
  name: "NumberRange"
};
</script>

<style lang="less" scoped>
.number-range {
  display: flex;
  align-items: center;

  .compact-form-item {
    display: inline-flex;
  }

  .number-input,
  .text-input {
    width: 45%;
  }
  .separate {
    text-align: center;
    width: 10%;
    border-top: 0;
    border-bottom: 0;
    pointer-events: none;
    background-color: #fff;
    padding: 4px 0px;
  }
}
</style>
